import { NETWORK_ERROR_CODE } from "@atlassian/company-hub-common";

import type { TFetchError } from "../types";

export const isFetchNetworkError = (err: TFetchError): boolean => {
    return err.status === NETWORK_ERROR_CODE;
};

export const isFetchClientError = (err: TFetchError): boolean => {
    return err.status >= 400 && err.status < 500;
};

export const isFetchNetworkOrClientError = (err: TFetchError): boolean => {
    return isFetchNetworkError(err) || isFetchClientError(err);
};
